import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToIdWhenReady } from "@/lib/scroll-to-hash";

/**
 * Global handler for URL hashes (e.g. `/hospital-curbside-econsult#pricing`).
 *
 * Routes are lazy-loaded, so the browser's native anchor jump fires before the
 * target section exists. This waits for the element to render, then scrolls to
 * it with an offset for the fixed header. If it never appears, nothing happens.
 */
export function HashScrollTo() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = decodeURIComponent(hash.slice(1));
    if (!id) return;
    return scrollToIdWhenReady(id);
  }, [pathname, hash]);

  return null;
}
